import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=11c728a6&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=11c728a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c728a6",
  null
  
)

export default component.exports